// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__vvHDm","infoWrapper":"styles_infoWrapper__UoZuf","title":"styles_title__hzeKg","info":"styles_info__iFiLq","buttonWrapper":"styles_buttonWrapper__eW_L2","button":"styles_button__Kop5J"};
module.exports.__checksum = "263d38343146"